const upperFirst = function(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
};

export default upperFirst;
//# sourceMappingURL=upperFirst.js.map
